/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformEphemerisDailyResponse } from '../../models/platform-ephemeris-daily-response';

export interface GetEphemerisDaily$Params {

/**
 * Begin van het venster (ISO-8601, UTC). Verplicht.
 */
  fromUtc?: string | null;

/**
 * Einde van het venster (ISO-8601, UTC, exclusief). Verplicht, na fromUtc.
 */
  toUtc?: string | null;

/**
 * Optioneel: IANA-tijdzone (bv. "Europe/Brussels") waarin de rijen op 00:00 en 12:00 vallen.
 * Default "UTC" (klassiek). Met een lokale zone volgen de rijen de zomertijd.
 */
  timeZone?: string | null;
}

export function getEphemerisDaily(http: HttpClient, rootUrl: string, params?: GetEphemerisDaily$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisDailyResponse>> {
  const rb = new RequestBuilder(rootUrl, getEphemerisDaily.PATH, 'get');
  if (params) {
    rb.query('fromUtc', params.fromUtc, {});
    rb.query('toUtc', params.toUtc, {});
    rb.query('timeZone', params.timeZone, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformEphemerisDailyResponse>;
    })
  );
}

getEphemerisDaily.PATH = '/api/Ephemeris/daily';
